import Phaser from 'phaser'
import SizeEditor from '../editor/sizeEditor'
import Editable from './editable'
import Platform from './platform'

export default class BreakablePlatform extends Platform {
  constructor (scene, args, doSave = true) {
    super(scene, args, doSave)
    this.typeName = 'bPl'
    // this.image.setTint(0xFFFFFF)
    this.enabled = true
  }

  onHit () {
    return

    if (this.enabled) {
      this.colorIm.setVisible(false)
      this.image.setAlpha(0.25)
      this.image.setCollisionCategory(this.scene.collisionCatNO_COLL)
      this.image.setCollisionGroup(this.scene.collisionGroupNO_COLL)
      this.enabled = false
      // setTimeout(() => { this.enable() }, 5000)
    }
  }

  enable () {
    if (!this.enabled) {
      this.colorIm.setVisible(true)
      this.image.setAlpha(1)
      this.image.setCollisionGroup(this.scene.collisionGroup1)
      this.image.setCollisionCategory(this.scene.collisionCategory2)
      this.enabled = true
    }
  }
}
